
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { successToaster, errorToaster } from "../../utils";
import apiClient from "../../utils/api";

import Compressor from "compressorjs";

function SliderUpload(props) {
  const { imgId = 1 } = props;
  const [data, setData] = useState([]);
  const [imgData, setImgData] = useState([]);

  const onChangeHandler = (e) => {
    if (e.target.name === "img") {
      if (e.target.files && e.target.files.length > 0) {
        setData({ ...data, ["img"]: URL.createObjectURL(e.target.files[0]) });
        setImgData(e.target.files[0]);
      }
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        maxWidth: 1275,
        maxHeight: 400,
        success(result) {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(result);
        },
        error(err) {
          reject(err);
        },
      });
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const file = imgData;
    const base64 = await convertToBase64(file);
    apiClient
      .post(`put/user_landingpage.php`, {
        path: base64,
        link: data.link,
        image_id: imgId,
      })
      .then((res) => {
        if (res.data === "Success") {
          successToaster({ msg: "Slide upload successfully" });
          setData([]);
          setImgData([]);
          form.reset();
        } else {
          errorToaster({ msg: "Upload failed: " + res.data });
        }
      })
      .catch((err) => {
        console.log(err);
        errorToaster({ msg: "API Error occurred" });
      });
  };

  return (
    <>
      <form className="tab-pane active" onSubmit={onSubmit}>
        <div className="mt-2">
          <input
            type="text"
            value={data?.link || ""}
            placeholder="ENTER SLIDE LINK"
            className="p-1 linkInput"
            required
            name="link"
            onChange={onChangeHandler}
          />
          <div className="button-wrapper py-2">
            <span className="label">Upload File</span>
            <input
              required
              type="file"
              id="upload"
              className="upload-box"
              name="img"
              onChange={onChangeHandler}
            />
          </div>
          <div className="previewDiv">
            {data?.img && (
              <img src={data?.img} height="200" width="200" alt="med1" />
            )}
          </div>
        </div>
        <div className="py-2 text-center submitBtn">
          <button className=" text-uppercase">{props.buttonText}</button>
        </div>
      </form>
    </>
  );
}
export default SliderUpload;
